import { adfModelTypeMap, fileTypeLinkedServiceTypes } from 'app/registries/consts/adf-model-type-map-const';
import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { compressionCodecOptions } from './delimitedtext-metadata';
import { ColumnType, defaultSupportedColumnTypes } from 'app/shared/utils/column-type.util';

export const excelMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.excel.datasetType,
    displayName: stringResources.ModelName_ExcelDataset,
    supportLinkedServiceTypes: __IS_FABRIC_DPE__ ? fileTypeLinkedServiceTypes : fileTypeLinkedServiceTypes.filter((type) => type !== adfModelTypeMap.lakehouse.linkedServiceType),
    supportDeleteActivity: true,
    isSource: true,
    isSink: false,
    datasetKind: 'file',
    icon: {
        className: 'svg-i-20x20-excel'
    },
    isFirstClass: true,
    category: ['File'],
    isV2FormatDataset: true,
    supportDataFlowSource: true,
    supportGetMetadataActivity: true,
    supportDataTypes: defaultSupportedColumnTypes.concat(ColumnType.Date),
    compressionOptions: compressionCodecOptions,
    fileExtensions: [
        '*.xls', '*.xlsx', '*'
    ]
};
